export default __webpack_public_path__ + "static/people-338b63ccd3a4c20a5cf79327ea53e013.jpg";